import React, { FC } from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';

export const ZipCodeFilter: FC = () => {
  const [field, meta] = useField<string>({ name: 'zipCode' });

  return (
    <FormField
      label={<Label>Zip Code</Label>}
      control={<Input {...field} autoComplete={'off'} />}
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
